import Modal from "react-bootstrap/Modal";
import { TbChartBar, TbChevronRight } from "react-icons/tb";
import { Class } from "../../types";
import "./SelectQuestionBankModal.scss";

type SelectQuestionBankModalProps = {
  show: boolean;
  onHide: () => void;
  enrolments: Class[];
  onSelect: (subjectId: number) => void;
};

const SelectQuestionBankModal = ({
  show,
  onHide,
  enrolments,
  onSelect,
}: SelectQuestionBankModalProps) => (
  <Modal
    show={show}
    onHide={onHide}
    centered
    dialogClassName="select-question-bank-modal"
    contentClassName="select-question-bank-modal__content"
  >
    <Modal.Header closeButton closeLabel="Close" className="select-question-bank-modal__header">
      <Modal.Title as="div" className="select-question-bank-modal__title">
        Select question bank
      </Modal.Title>
    </Modal.Header>
    <Modal.Body className="select-question-bank-modal__body">
      <p className="select-question-bank-modal__intro">
        Usage statistics are tracked separately for each question bank. Choose which one
        you&apos;d like to view.
      </p>
      <ul className="select-question-bank-modal__list">
        {enrolments.map((enrolment) => (
          <li key={enrolment.classId}>
            <button
              type="button"
              className="select-question-bank-modal__option"
              onClick={() => onSelect(enrolment.subjectId)}
            >
              <span className="select-question-bank-modal__option-icon" aria-hidden="true">
                <TbChartBar />
              </span>
              <span className="select-question-bank-modal__option-text">
                <span className="select-question-bank-modal__option-name">
                  {enrolment.className}
                </span>
                {enrolment.subjectName !== enrolment.className ? (
                  <span className="select-question-bank-modal__option-sub">
                    {enrolment.subjectName}
                  </span>
                ) : null}
              </span>
              <TbChevronRight
                className="select-question-bank-modal__option-arrow"
                aria-hidden="true"
              />
            </button>
          </li>
        ))}
      </ul>
    </Modal.Body>
  </Modal>
);

export default SelectQuestionBankModal;
